import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SubscribePushDto } from "@myapp/contract";
import { writeDeviceId } from "../../../../shared/lib/push";
import { notificationKeys } from "../notification.keys";
import { notificationApi } from "../service";

/**
 * Registers this device. Also the re-register path — the server upserts on the endpoint, so
 * posting the same subscription again is a cheap, idempotent "still here".
 */
export function useSubscribePush() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: SubscribePushDto) =>
      notificationApi.subscribe(dto).then((response) => response.data),
    onSuccess: (device) => {
      writeDeviceId(device.id);
      queryClient.invalidateQueries({ queryKey: notificationKeys.devices() });
    },
  });
}
